import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/components/notifications/notifications-page";

export const Route = createFileRoute("/user/_layout/notifications")({
  component: () => <NotificationsPage audience="USER" />,
});
